import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import ExamAttemptsTable from './ExamAttemptsTable';

const ExamAttempts = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Exam Attempts' parent='Users' />
      <Container fluid={true}>
        <Row>
          <ExamAttemptsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ExamAttempts;
